import type {
  ICancelCartDtoData,
  ICartResponseDtoData,
  IChangeDeliveryDateBodyDtoData,
  ICompleteCartDtoData
} from '~/dtos/ProdegaApiWebshop-api-typings-generated';

export type CartResponseData = MakeOptional<ICartResponseDtoData>;
export type PositionIntentActorResponse = CartResponseData & {
  articleDescriptionForErrorMessage?: string;
  isCsvImport: boolean | undefined;
};

export type MutatePositionBody = {
  positionId: number;
  payload: MutatePositionPayload;
};

export type MutatePositionPayload = {
  articleNumber: string;
  quantity: number;
  deliveryDate: string;
  externalArticle: boolean;
};

export type CopyExistingOrderToCartPayload = {
  currentOrderId: number;
  existingOrderId: number;
};

export type CopyTemplateArticleToCartPayload = {
  currentOrderId: number;
  templateId: number;
  selectedMainArticleIds?: number[];
};

export type CopySalesOrderSetArticleToCartPayload = {
  currentOrderId: number;
  articles: { articleNumber: string; quantity: number }[];
};

export type ImportCsvToCartPayload = {
  currentOrderId: number;
  csvText: string;
};

export type SendCartUserData = Pick<ICompleteCartDtoData, 'reference' | 'remarks'>;

export type CancelCartData = WithUndefined<ICancelCartDtoData, 'orderId'>;
export type ChangeDeliveryDateData = WithUndefined<IChangeDeliveryDateBodyDtoData, 'orderId'>;

export const CANCEL_REASONS = {
  // CancelReason must be consistent with the Backend. See: com/prodega/model/customerorder/CposCancelReason.java
  OCI: 10,
  CANCELLED_BY_CUSTOMER: 11,
  ORDER_EXPIRED: 12
} as const;
export type CancelReasonType = (typeof CANCEL_REASONS)[keyof typeof CANCEL_REASONS];

export type AddPositionIntent = {
  operation: 'ADD';
  articleNumber: string;
  quantity: number;
  externalArticle: boolean;
  articleDescriptionForErrorMessage: string; // Wird verwendet, um im Fehlerfall dem Benutzer eine verständlichere Meldung anzuzeigen.
};

export type MutatePositionIntent = {
  operation: 'MUTATE';
  positionId: number;
  articleNumber: string;
  quantity: number;
  deliveryDate: string;
  externalArticle: boolean;
};

export type RemovePositionIntent = {
  operation: 'REMOVE';
  positionId: number;
  externalArticle: boolean;
};

export type CopyExistingOrderToCartIntent = {
  operation: 'COPY_EXISTING_ORDER_TO_CART';
  existingOrderId: number;
};

export type CopyTemplateArticleToCartIntent = {
  operation: 'COPY_TEMPLATE_ARTICLE_TO_CART';
  templateId: number;
  selectedMainArticleIds?: number[];
};

export type CopySalesOrderSetArticleToCartIntent = {
  operation: 'COPY_SALESORDERSET_TO_CART';
  articles: { articleNumber: string; quantity: number }[];
};

export type ImportCsvToCartIntent = {
  operation: 'IMPORT_CSV_TO_CART';
  csvText: string;
};

export type PositionIntent =
  | AddPositionIntent
  | RemovePositionIntent
  | MutatePositionIntent
  | CopyExistingOrderToCartIntent
  | CopyTemplateArticleToCartIntent
  | CopySalesOrderSetArticleToCartIntent
  | ImportCsvToCartIntent;

export type MakeOptional<T> = {
  [P in keyof T]?: T[P];
};

type WithUndefined<T, K extends keyof T> = Omit<T, K> & { [P in K]: T[P] | undefined };
